import {createSlice} from "@reduxjs/toolkit";
import {aplicarMascaraCEP} from "../../../../lib/formatarCampos";
const initialProdutosState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  produtoForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const produtosSlice = createSlice({
  name: "produtos",
  initialState: initialProdutosState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    // getProdutoById
    tipoProdutoFetched: (state, action) => {
      state.listLoading = false;
      // APLICAR A MASCARA
      state.produtoForEdit = action.payload.tipoProdutoForEdit;
      state.error = null;
    },
    // findProdutos
    produtosFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createProduto
    tipoProdutoCreated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      // state.entities.push(action.payload.tipoProduto);
    },
    // updateProduto
    tipoProdutoUpdated: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.tipoProduto.idProduto) {
          return action.payload.tipoProduto;
        }
        return entity;
      });
    },
    // deleteProduto
    tipoProdutoDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteProdutos
    produtosDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // produtosUpdateState
    produtosStatusUpdated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
